import React from "react";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import updateData from "immutability-helper";
import {
  Row,
  Col,
  message,
  Form,
  Button,
  Switch,
  Checkbox,
  Input,
  Select,
  Tooltip,
  InputNumber,
  Divider,
  Spin,
  DatePicker,
  Radio,
} from "antd";
import { add, deleteRecord, getDetails, list, update } from "../api/Apis";
import appConfig from "../config/AppConfig";
import { Storage } from "aws-amplify";
import { withAppContext } from "../Store/AppContext";
import { withRouter } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import BaseTable from "./BaseTable";
import BaseModal from "./BaseModal";
import TextArea from "antd/lib/input/TextArea";
import {
  PlusOutlined,
  UsergroupAddOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { v4 as uuidv4 } from "uuid";
import Loading from "./Loading";
import NumberFormat from "react-number-format";
import moment from "moment";
import QuarryJsonData from "../Json/quarryData.json";
import Dragger from "antd/lib/upload/Dragger";

const { Option } = Select;

const jobType = [
  { label: "Trucking Job", value: "Trucking Job" },
  { label: "Trucking & Material Job", value: "Both" },
];

const dummyRequest = ({ file, onSuccess }) => {
  setTimeout(() => {
    onSuccess("ok");
  }, 0);
};

const stageConditions = {
  "Uncontacted Lead": [
    "Pending Carrier Packet + Insurance",
    "Archived Carrier",
    "Stalled Application",
  ],
  "Pending Carrier Packet + Insurance": [
    "Uncontacted Lead",
    "Pending Insurance",
    "Pending Carrier Packet",
    "Archived Carrier",
    "Carrier Data Input",
    "Stalled Application",
  ],
  "Pending Insurance": [
    "Uncontacted Lead",
    "Pending Carrier Packet + Insurance",
    "Carrier Data Input",
    "Archived Carrier",
    "Stalled Application",
  ],
  "Pending Carrier Packet": [
    "Uncontacted Lead",
    "Pending Carrier Packet + Insurance",
    "Pending Insurance",
    "Carrier Data Input",
    "Archived Carrier",
    "Stalled Application",
  ],
  "Carrier Data Input": [
    "Uncontacted Lead",
    "Pending Carrier Packet + Insurance",
    "Pending Insurance",
    "Pending Carrier Packet",
    "Welcome Call",
    "Archived Carrier",
    "Stalled Application",
  ],
  "Welcome Call": [
    "Uncontacted Lead",
    "Pending Carrier Packet + Insurance",
    "Pending Insurance",
    "Pending Carrier Packet",
    "Carrier Data Input",
    "Approved Carrier",
    "Archived Carrier",
    "Stalled Application",
  ],
  "Approved Carrier": [],
  "Archived Carrier": [
    "Pending Carrier Packet + Insurance",
    "Stalled Application",
  ],
  "Stalled Application": ["Pending Carrier Packet + Insurance"],
};

// KanbanItem Component using hooks
const KanbanItem = ({ id, onDrop, children, isOwnerOperator }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "kanbanItem",
    item: { name: id },
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult();
      if (dropResult && item.name) {
        onDrop(item.name, dropResult.name);
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  const opacity = isDragging ? 0.4 : 1;

  return (
    <div ref={drag} style={{ opacity, cursor: "move" }}>
      {children}
    </div>
  );
};

// KanbanColumn Component using hooks
const KanbanColumn = ({ status, children, isOwnerOperator }) => {
  const [{ canDrop, isOver }, drop] = useDrop(() => ({
    accept: "kanbanItem",
    drop: () => ({ name: status }),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }));

  const isActive = canDrop && isOver;
  const backgroundColor = isActive ? "#e6f7ff" : "#fff";

  return (
    <div ref={drop} style={{ backgroundColor, minHeight: "100%" }}>
      {children}
    </div>
  );
};

class DraggableCard extends React.Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      funnelData: [],
      leadsData: [],
      funnelId: "",
      isHovering: false,
      isModalVisible: false,
      isContactVisible: false,
      leadDetails: "",
      contactsData: [],
      trucksData: [],
      dropAddress: "",
      jobInfo: "",
      dropoffLatitude: "",
      dropoffLongitude: "",
      seperate: false,
      initialMaterialCost: "",
      materialPriceState: "",
      selectVendor: "",
      materialValue: "",
      categoriesList: [],
      materialCostPrice: "",
      materialTruckPrice: 0,
      milesData: "",
      duration: "",
      vendorName: "",
      quantity: 1,
      masterRoleId: "",
      masterTruckId: "",
      truckingPriceType: "Ton",
      quantityType: "Ton",
      totalPriceType: "Ton",
      materialCostType: "Ton",
      truckingCostType: "Ton",
      leadQuote: [],
      selectedMaterial: [],
      selectedMaterialType: "",
      truckId: "",
      localTruckId: "",
      openDropdown: "",
      topVendorsData: [],
      vendorData: [],
      customRate: false,
      materialCustomRate: false,
      vendorDetails: "",
      salesCommission: "",
      addTruck: false,
      imageLoading: false,
      overWeightPermitState: "",
      companyData: {},
      selectedTruckCode: "",
      fileType: "",
    };
  }

  componentDidMount() {
    AOS.init({
      duration: 2000,
    });
    this.getDropDownOptions();
  }

  static getDerivedStateFromProps(props) {
    return {
      funnelData: props.headingData,
      leadsData: props.contentData.sort((a, b) =>
        a.createdAt < b.createdAt ? 1 : -1
      ),
    };
  }

  getLeadDetails = (id) => {
    getDetails(appConfig["entityNames"]["singleLead"], id).then((result) => {
      if (result.success) {
        this.setState({
          isModalVisible: true,
          jobInfo: result.data?.jobType,
          jobEditModal: true,
          selectedMaterial: result.data?.material ? result.data?.material : [],
          selectedTruckType: result.data?.truckType,
          selectedMaterialType: "",
          selectedDropOffAddress: result.data?.dropoff,
          dropAddress: result.data?.dropoff,
          leadQuote: result.data?.multipleContacts,
          dropoffLatitude: result.data?.dropOffLatLng?.lat,
          dropoffLongitude: result.data?.dropOffLatLng?.lng,
          taxExempt: result.data?.taxExempt,
          leadDetails: result.data,
          openDropdown: result.data?.taxExempt
            ? result.data?.taxExempt
            : "Material is quoted as",
        });
        this.getCompanyContacts(
          result?.data?.companyId,
          result.data?.multipleContacts
        );
      } else {
        this.setState({
          loading: false,
          errorLoading: true,
        });
      }
    });
  };

  getCompanyContacts = (id, jobContacts) => {
    getDetails(appConfig["entityNames"]["companyDetails"], id).then(
      (result) => {
        let quarryContacts = [];
        if (result.success) {
          quarryContacts = jobContacts.concat(result.data.contactDetails);
          this.setState({
            contactsData: quarryContacts?.filter(
              (value, index, self) =>
                index === self.findIndex((t) => t?.id === value?.id)
            ),
            companyId: id,
          });
        }
      }
    );
  };

  getDropDownOptions = () => {
    list("dropDownOptions", { typeofDropDown: "material" }).then((result) => {
      let materialData = {};
      result.data[0]?.materialsNewList?.forEach((eachMat, index) => {
        if (eachMat?.statusCode) {
          materialData[eachMat.category] = !Object.keys(materialData).includes(
            eachMat.category
          )
            ? []
            : materialData[eachMat.category];
        }
      });
      this.setState({
        materialCategory: materialData,
        materialList: result.data[0]?.materialsNewList,
      });
    });
  };

  onSelectLead = (e) => {
    const { contactsData } = this.state;
    let data = contactsData?.filter((contact) => e?.includes(contact?.id));
    this.setState({ leadQuote: data, contactId: e });
  };

  update = (id, status) => {
    const { leadsData } = this.state;
    const taskData = leadsData.find((task) => task.id === id);

    if (taskData?.stageId === "Job Lead" && status === "Contacted") {
      this.updateStage(id, status, taskData);
    } else if (
      (taskData?.stageId === "Contacted" || taskData?.stageId === "Paused") &&
      status === "Build Quote"
    ) {
      if (taskData?.fileName) {
        message.info("Quote is already generated for this job");
      } else {
        this.getLeadDetails(id);
        this.setState({
          selectedStatus: status,
        });
      }
    } else if (
      taskData?.stageId === "Build Quote" &&
      (status === "Quote Delivered" ||
        status === "Quote Accepted" ||
        status === "Dispatch Approved" ||
        status === "Paused" ||
        status === "Close Job")
    ) {
      this.updateStage(id, status, taskData);
    } else if (
      taskData?.stageId === "Quote Delivered" &&
      (status === "Quote Accepted" ||
        status === "Dispatch Approved" ||
        status === "Paused" ||
        status === "Close Job")
    ) {
      this.updateStage(id, status, taskData);
    } else if (
      taskData?.stageId === "Quote Accepted" &&
      (status === "Dispatch Approved" ||
        status === "Paused" ||
        status === "Close Job")
    ) {
      this.updateStage(id, status, taskData);
    } else if (
      taskData?.stageId === "Dispatch Approved" &&
      (status === "Paused" || status === "Close Job")
    ) {
      this.updateStage(id, status, taskData);
    } else if (
      taskData?.stageId === "Paused" &&
      (status === "Quote Delivered" ||
        status === "Quote Accepted" ||
        status === "Contacted" ||
        status === "Close Job")
    ) {
      this.updateStage(id, status, taskData);
    } else if (
      taskData?.stageId === "Close Job" &&
      (status === "Quote Delivered" ||
        status === "Quote Accepted" ||
        status === "Contacted" ||
        status === "Dispatch Approved" ||
        status === "Paused")
    ) {
      message.info("This Job is closed");
    }
  };

  updateStage = (id, status, taskData) => {
    const { leadsData } = this.state;
    taskData.stageId = status;
    const taskIndex = leadsData.indexOf(taskData);
    let data = {
      entityData: {
        stageId: taskData["stageId"],
      },
    };
    const newTasks = updateData(taskData, {
      [taskIndex]: { $set: taskData },
    });
    this.setState({
      taskData: newTasks,
    });

    update(appConfig["entityNames"]["updateLead"], id, data)
      .then((result) => {
        message.success(`Status updated to ${status}`);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  updateCompany = (id, status) => {
    const { leadsData } = this.state;
    const taskData = leadsData.find((task) => task.id === id);
    if (
      taskData?.stageId === "Carrier Data Input" &&
      status === "Welcome Call"
    ) {
      this.welcomeCallCondition(id, status, taskData);
      this.setState({
        companyData: taskData,
        selectedAddress: taskData?.address,
        latitude: taskData?.lat,
        longitude: taskData?.lng,
      });
    } else if (
      taskData?.stageId === "Welcome Call" &&
      status === "Approved Carrier"
    ) {
      taskData.stageId = status;
      const taskIndex = leadsData.indexOf(taskData);
      let data = {
        entityData: {
          stageId: taskData["stageId"],
        },
      };
      const newTasks = updateData(leadsData, {
        [taskIndex]: { $set: taskData },
      });
      this.setState({
        leadsData: newTasks,
        loading: true,
      });
      update(appConfig["entityNames"]["updateCompany"], id, data)
        .then((result) => {
          if (result.success) {
            this.addToMasterData(taskData);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (
      taskData?.stageId === "Stalled Application" &&
      status === "Pending Carrier Packet + Insurance"
    ) {
      const { leadsData } = this.state;
      taskData.stageId = status;
      const taskIndex = leadsData.indexOf(taskData);
      let data = {
        entityData: {
          stageId: taskData["stageId"],
          stageIdUpdatedDate: moment().format("L"),
          registeredSince: moment().format("L"),
          createdAt: Date.now(),
        },
      };
      const newTasks = updateData(leadsData, {
        [taskIndex]: { $set: taskData },
      });
      this.setState({
        leadsData: newTasks,
      });
      update(appConfig["entityNames"]["updateCompany"], id, data)
        .then((result) => {})
        .catch((err) => {
          console.log(err);
        });
    } else if (stageConditions[taskData?.stageId].includes(status)) {
      this.updateOwnerStage(id, status, taskData);
    }
  };

  addToMasterData = (taskData) => {
    let finalData = {
      entityData: {
        ...taskData,
      },
    };
    add("trucksList", finalData).then((res) => {
      if (res.success) {
        message.info(
          `${res.data.data.carrier_name} Added To TNBS Owner Operator Successfully`
        );
        this.setState({ loading: false });
      }
    });
  };

  updateOwnerStage = (id, status, taskData) => {
    const { leadsData } = this.state;
    taskData.stageId = status;
    const taskIndex = leadsData.indexOf(taskData);
    let data = {
      entityData: {
        stageId: taskData["stageId"],
        stageIdUpdatedDate: moment().format("L"),
      },
    };
    const newTasks = updateData(leadsData, {
      [taskIndex]: { $set: taskData },
    });
    this.setState({
      leadsData: newTasks,
    });
    update(appConfig["entityNames"]["updateCompany"], id, data)
      .then((result) => {})
      .catch((err) => {
        console.log(err);
      });
  };

  getCompanies = (id, status, taskData) => {
    this.setState({ loading: true });
    list("companies").then((result) => {
      if (result.success) {
        let data = [];
        let finalRes = result.data.filter((c) => c.isOwnerOperator);
        finalRes.forEach((e) => {
          if (e?.isOwnerOperator && e?.carrierDetails?.length > 0) {
            e?.carrierDetails?.forEach((c) => {
              if (c?.truckId !== null && c?.truckId !== undefined) {
                data.push(parseInt(c?.truckId));
              }
            });
          }
        });
        let res = data?.length > 0 ? data.flat() : [0];
        let truckIdLocal = Math.max(...res);
        this.setState(
          {
            localTruckId: truckIdLocal,
          },
          () => this.getTwistedNailData(id, status, taskData)
        );
      } else {
        this.setState({ loading: false, errorLoading: true });
      }
    });
  };

  getTwistedNailData = (id, status, taskData) => {
    list("trucksList")
      .then((result) => {
        if (result.success) {
          let data = [];
          result.data.forEach((e) => {
            if (e?.carrierDetails?.length > 0) {
              e?.carrierDetails?.forEach((c) => {
                if (c?.truckId !== null && c?.truckId !== undefined) {
                  data.push(parseInt(c?.truckId));
                }
              });
            }
          });
          let res = data?.length > 0 ? data.flat() : [100];
          let truckIdLocal = Math.max(...res);
          this.setState(
            {
              truckId: truckIdLocal,
            },
            () => this.addTruckId(id, status, taskData?.carrierDetails)
          );
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          loading: false,
        });
      });
  };

  addTruckId = (id, status, data) => {
    const { truckId, localTruckId } = this.state;

    let count = 0;
    if (Array.isArray(data) && data?.length > 0) {
      for (let i of data) {
        count += 1;
        if (localTruckId > truckId) {
          i["truckId"] = localTruckId + count;
        } else {
          i["truckId"] = truckId + count;
        }
      }
      let finalData = {
        entityData: {
          carrierDetails: data,
          stageId: status,
        },
      };
      this.updateCompanyDetails(id, finalData);
    }
  };

  updateCompanyDetails = (id, data) => {
    update(appConfig["entityNames"]["updateCompany"], id, data)
      .then((res) => {
        if (res.success) {
          this.getCompanies();
          this.props.onResetData();
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onDoubleClick = (id) => {
    this.props.history.push(`/app/jobs/job-profile/${id}`);
  };

  handleMouseEnter = (id) => {
    this.setState({
      isHovering: id,
    });
  };

  handleMouseLeave = (id) => {
    this.setState({
      isHovering: false,
    });
  };

  editModal = (record) => {
    this.setState({ isContactVisible: true, jobContactData: record });
  };

  getAddress = (address, type) => {
    if (type === "pickup") {
      this.setState({
        selectedPickupAddress: address.label,
      });
    } else if (type === "dropOff") {
      this.setState({
        selectedDropOffAddress: address.label,
      });
    } else {
      this.setState({ selectedAddress: address.label });
    }
  };

  handleSelect = (address, type) => {
    const { dropoffLatitude, dropoffLongitude } = this.state;
    const citySearch = [];
    citySearch.push(address.label);
    this.setState({
      citySearch,
    });
    let cityValue = "";
    let stateValue = "";
    let zipCodeValue = "";
    geocodeByAddress(address.label)
      .then((results) => {
        getLatLng(results[0]).then(({ lat, lng }) => {
          if (type === "pickup") {
            this.setState({
              loading: true,
            });
            let url =
              "https://maps.googleapis.com/maps/api/distancematrix/json?units=imperial&destinations=" +
              [dropoffLatitude, dropoffLongitude] +
              "&origins=" +
              [lat, lng] +
              "&key=AIzaSyB781k9fNf61hnxE3A6cvcascwhAhIVIK4";
            let milesData = {
              entityData: {
                url,
              },
            };
            add("getMiles", milesData)
              .then((res) =>
                this.setState({
                  pickUpLatitude: lat,
                  pickupLongitude: lng,
                  milesData: res.data.distance,
                  duration: res.data.duration,
                  loading: false,
                })
              )
              .catch((err) => {
                this.setState({
                  loading: false,
                });
                console.log(err, "err");
              });
          } else if (type === "dropOff") {
            this.setState({ dropoffLatitude: lat, dropoffLongitude: lng });
          } else {
            this.setState({ latitude: lat, longitude: lng });
          }
        });
        const geoIdData = results[0];
        this.setState({
          geoIdData,
        });
        let address = results[0].address_components;
        for (let i = 0; i < address?.length; i++) {
          if (address[i].types[0] === "locality") {
            cityValue = address[i].long_name;
          }
          if (address[i].types[0] === "administrative_area_level_1") {
            stateValue = address[i].short_name;
          }
          if (address[i].types[0] === "postal_code") {
            zipCodeValue = address[i].long_name;
          }
        }
        this.setState({
          city: cityValue,
          addressState: stateValue,
          zipCode: zipCodeValue,
        });
      })
      .catch((error) => console.error("Error", error));
  };

  onChangeTrucksType = (values) => {
    this.setState({ selectedTruckType: values });
  };

  onFinish = (values) => {
    const {
      leadDetails,
      selectedStatus,
      jobInfo,
      selectedTruckType,
      selectedMaterial,
      leadQuote,
      dropoffLatitude,
      dropoffLongitude,
      selectedDropOffAddress,
      salesCommission,
    } = this.state;
    const { match } = this.props;
    const { params } = match;
    const { id } = params;

    let accountPayableContact = leadQuote?.filter(
      (e) => e?.contactRole === "Accounts Payable"
    );

    let commonData = {
      contactperson: "",
      contactId: "",
      jobName: values["jobName"],
      jobType: values["jobType"],
      dropoff: selectedDropOffAddress,
      dropOffLatLng: {
        lat: dropoffLatitude,
        lng: dropoffLongitude,
      },
      multipleContacts: leadQuote,
      truckType: selectedTruckType,
      notes:
        values["notes"] === ""
          ? ""
          : values["notes"] !== ""
          ? values["notes"]
          : leadDetails?.notes,
      salesPersonId: values["salesPerson"],
      salesCommission,
      durationOfJob: values["durationOfJob"],
    };
    if (selectedStatus === "Build Quote") {
      let statusCommonData = {
        ...commonData,
        company: leadDetails?.companyDetails?.company,
        companyName: leadDetails?.companyDetails?.company,
        companyAddress: leadDetails?.companyDetails?.address,
        stageId: selectedStatus,
        accountsPayableContact: accountPayableContact,
        accountTerms: leadDetails?.companyDetails?.accountTerms,
      };
      if (jobInfo === "Trucking Job") {
        let leadData = {
          entityData: {
            ...statusCommonData,
            material: selectedMaterial,
          },
        };
        leadData.entityData.material.map((e) => (e["assigned"] = false));
        this.verificationTruckingJob(id, leadData);
      } else {
        let leadData = {
          entityData: {
            ...statusCommonData,
            taxExempt: values.taxExempt,
            taxIncluded: values.taxIncluded,
            taxStatus: values.taxIncluded === "Tax Added" ? true : false,
            seperate:
              this.state.seperate === true ? this.state.seperate : false,
            material: selectedMaterial,
          },
        };
        leadData.entityData.material.map((e) => (e["assigned"] = false));
        this.verificationTuckingAndMaterial(id, leadData);
      }
    }
  };

  verificationTruckingJob = (id, data) => {
    const { selectedMaterial, selectedTruckType, leadDetails } = this.state;
    if (
      selectedMaterial[0]?.pickUpAddress !== "" &&
      selectedMaterial[0]?.pickUpAddress !== undefined &&
      selectedMaterial?.length !== 0
    ) {
      if (selectedTruckType !== undefined && selectedTruckType?.length !== 0) {
        if (
          this.state?.dropAddress !== "" &&
          this.state?.dropAddress !== undefined
        ) {
          if (
            selectedMaterial[0]?.truckingCost !== "" &&
            selectedMaterial[0]?.truckingCost !== undefined &&
            selectedMaterial[0]?.truckingPrice !== "" &&
            selectedMaterial[0]?.truckingPrice !== undefined
          ) {
            if (
              leadDetails?.companyDetails?.accountTerms !== "" &&
              leadDetails?.companyDetails?.accountTerms !== undefined
            ) {
              this.setState({
                isModalVisible: false,
              });
              this.updateLead(leadDetails?.id, data);
            } else {
              message.error(
                "Please Enter Account Terms In Customer Account Profile To Proceed Further"
              );
            }
          } else {
            message.error("Please Enter Trucking Cost And Trucking Price");
          }
        } else {
          message.info("Please Select Dropoff Location");
        }
      } else {
        message.info("Please Select Truck Type");
      }
    } else {
      message.info("Please Select Pickup Address");
    }
  };

  verificationTuckingAndMaterial = (id, data) => {
    const { selectedMaterial, selectedTruckType, leadDetails } = this.state;
    let vendor = data.entityData.material?.filter((e) => e?.vendor);
    if (vendor?.length === data?.entityData?.material?.length) {
      if (selectedTruckType !== undefined && selectedTruckType?.length !== 0) {
        if (
          this.state?.dropAddress !== "" &&
          this.state?.dropAddress !== undefined
        ) {
          if (selectedMaterial?.length > 0) {
            if (
              leadDetails?.companyDetails?.accountTerms !== "" &&
              leadDetails?.companyDetails?.accountTerms !== undefined
            ) {
              this.setState({
                isModalVisible: false,
              });
              this.updateLead(leadDetails?.id, data);
            } else {
              message.error(
                "Please Enter Account Terms In Customer Account Profile To Proceed Further"
              );
            }
          } else {
            message.error("Please Select Required Materials");
          }
        } else {
          message.error("Please Select Dropoff Location");
        }
      } else {
        message.error("Please Select Truck Type");
      }
    } else {
      message.error("Please Add Vendor Details To Materials");
    }
  };

  updateLead = (id, data) => {
    this.setState({
      loading: true,
      isModalVisible: false,
    });
    if (data["entityData"]["stageId"] === "Dispatch Approved") {
      data["entityData"]["recurring"] = this.state.recurringData;
    }
    update(appConfig["entityNames"]["updateLead"], id, data)
      .then((result) => {
        if (result.success) {
          this.props.requestMethod();
          this.setState({
            loading: false,
            selectedMaterial: [],
            recordMaterialData: [],
            truckDropInfo: false,
            materialCostType: "Ton",
            truckingCostType: "Ton",
            quantityType: "Ton",
            totalPriceType: "Ton",
            showSpecificDate: false,
            iscalenderVisible: false,
            taxExempt: "",
            dropoffLatitude: "",
            dropoffLongitude: "",
          });
        } else {
          this.setState({
            loading: false,
            selectedMaterial: [],
            recordMaterialData: [],
            truckDropInfo: false,
            materialCostType: "Ton",
            truckingCostType: "Ton",
            quantityType: "Ton",
            totalPriceType: "Ton",
            showSpecificDate: false,
            iscalenderVisible: false,
            taxExempt: "",
            dropoffLatitude: "",
            dropoffLongitude: "",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loading: false,
          selectedMaterial: [],
          recordMaterialData: [],
          truckDropInfo: false,
          materialCostType: "Ton",
          truckingCostType: "Ton",
          quantityType: "Ton",
          totalPriceType: "Ton",
          showSpecificDate: false,
          iscalenderVisible: false,
          taxExempt: "",
          dropoffLatitude: "",
          dropoffLongitude: "",
        });
      });
  };

  onFinishMaterial = (values) => {
    const {
      recordMaterialData,
      materialSelectedData,
      quantityType,
      jobInfo,
      pickUpLatitude,
      pickupLongitude,
      truckingPriceType,
      selectedPickupAddress,
      initialMaterialCost,
      duration,
      milesData,
      totalPriceType,
      materialCostType,
      truckingCostType,
      vendorDetails,
      topVendorsData,
      materialPriceState,
      quantity,
      materialTruckPrice,
      truckingCost,
      diameter,
      selectedMaterial,
    } = this.state;

    if (jobInfo === "Trucking Job") {
      let truckingData = {
        entityData: {
          id:
            materialSelectedData["id"] === undefined
              ? uuidv4()
              : materialSelectedData["id"],
          truckingPrice:
            parseFloat(values["truckingPrice"]) ||
            recordMaterialData?.truckingPrice,
          truckingPriceType: truckingPriceType,
          pickUpAddress: selectedPickupAddress,
          pickUpLatLng: {
            lat: pickUpLatitude,
            lng: pickupLongitude,
          },
          truckingCost:
            parseFloat(values["truckingCost"]) ||
            recordMaterialData?.truckingCost,
          truckingCostType: truckingCostType,
          duration: duration,
          milesData: milesData,
        },
      };
      if (
        truckingData.entityData.pickUpAddress !== undefined &&
        truckingData.entityData.pickUpAddress !== ""
      ) {
        this.addMaterialOrTruckInfo(truckingData);
      } else {
        message.error("Please Enter PickUp Location");
      }
    } else {
      if (truckingPriceType === totalPriceType) {
        if (topVendorsData?.length === 0) {
          message.error("Please Find Nearest Vendors!");
          return true;
        }
        if (topVendorsData?.length !== 0 && vendorDetails === "") {
          message.error("Please select at least one Vendor!");
          return true;
        }
        let materialMinDiameter = 0,
          materialMaxDiameter = 0,
          materialDiameter = 0,
          filteredData = [];

        if (diameter) {
          materialMinDiameter =
            values["materialMinDiameter"].split(" ")?.length !== 2 &&
            String(parseInt(values["materialMinDiameter"])) !==
              values["materialMinDiameter"]
              ? this.DecimalToMixedFraction(values["materialMinDiameter"])
              : values["materialMinDiameter"];

          materialMaxDiameter =
            values["materialMaxDiameter"].split(" ")?.length !== 2 &&
            String(parseInt(values["materialMaxDiameter"])) !==
              values["materialMaxDiameter"]
              ? this.DecimalToMixedFraction(values["materialMaxDiameter"])
              : values["materialMaxDiameter"];
        } else {
          materialDiameter =
            values["materialDiameter"].split(" ")?.length !== 2 &&
            String(parseInt(values["materialDiameter"])) !==
              values["materialDiameter"]
              ? this.DecimalToMixedFraction(values["materialDiameter"])
              : values["materialDiameter"];
        }

        selectedMaterial?.forEach((c) => {
          if (
            c.vendorId === vendorDetails?.vendorId &&
            c.id === materialSelectedData?.id &&
            (c.diameter
              ? c["materialMinDiameter"] === materialMinDiameter &&
                c["materialMaxDiameter"] === materialMaxDiameter
              : c["materialDiameter"] === materialDiameter)
          ) {
          } else {
            filteredData.push(c);
          }
        });
        if (
          filteredData.filter(
            (e) =>
              e.vendorId === vendorDetails?.id &&
              e.id === materialSelectedData["id"] &&
              (e.diameter
                ? e["materialMinDiameter"] === materialMinDiameter &&
                  e["materialMaxDiameter"] === materialMaxDiameter
                : e["materialDiameter"] === materialDiameter)
          )?.length > 0
        ) {
          message.error("You can't select same material with same vendor!");
          return true;
        }
        let materialData = {
          entityData: {
            id: materialSelectedData["id"],
            label: materialSelectedData["label"],
            value:
              vendorDetails?.material && vendorDetails?.material[0]["value"],
            category: materialSelectedData["category"],
            categoryKey: materialSelectedData["categoryKey"],
            subShortName: materialSelectedData["subShortName"],
            materialShortValue:
              materialSelectedData["categoryKey"] +
              " - " +
              materialSelectedData["subShortName"] +
              " - " +
              materialSelectedData["label"].split(" - ")[1],
            truckingPrice: materialTruckPrice,
            truckingPriceType: truckingPriceType,
            truckingCost: truckingCost,
            truckingCostType: truckingCostType,
            quantity: quantity,
            quantityType: quantityType,
            vendorId: vendorDetails?.id,
            vendor: vendorDetails?.quarryName,
            vendorTerms:
              vendorDetails?.accountTerms || materialSelectedData?.vendorTerms,
            vendorDiscountTerms:
              vendorDetails?.payDiscountTerms ||
              materialSelectedData?.vendorDiscountTerms,
            vendorDiscount:
              vendorDetails?.payDiscount ||
              materialSelectedData?.vendorDiscount,
            pickUpAddress: vendorDetails?.address,
            pickUpLatLng: {
              lat: vendorDetails?.lat,
              lng: vendorDetails?.lng,
            },
            materialCost: parseFloat(initialMaterialCost),
            materialCostType: materialCostType,
            totalPrice: materialPriceState,
            totalPriceType: totalPriceType,
            duration: vendorDetails?.duration || materialSelectedData?.duration,
            milesData:
              vendorDetails?.distance || materialSelectedData?.milesData,
            materialCostAtQuarryPerTon: parseFloat(initialMaterialCost),
            landedPrice:
              totalPriceType === truckingPriceType
                ? parseFloat(materialPriceState) + materialTruckPrice
                : "N/A",
            landedCost:
              materialCostType === truckingCostType &&
              initialMaterialCost &&
              truckingCost
                ? parseFloat(initialMaterialCost + truckingCost)?.toFixed(2)
                : "N/A",
            totalSale:
              materialPriceState && quantity && materialTruckPrice
                ? parseFloat(
                    (materialPriceState + materialTruckPrice) * quantity
                  )?.toFixed(2)
                : "N/A",
            totalExepense:
              initialMaterialCost && quantity && truckingCost
                ? parseFloat(
                    (initialMaterialCost + truckingCost) * quantity
                  )?.toFixed(2)
                : "",
            totalProfit:
              materialPriceState !== undefined &&
              materialPriceState !== "" &&
              materialTruckPrice !== undefined &&
              materialTruckPrice !== "" &&
              quantity !== undefined &&
              quantity !== "" &&
              initialMaterialCost !== undefined &&
              initialMaterialCost !== "" &&
              materialTruckPrice !== undefined &&
              materialTruckPrice !== "" &&
              truckingCost !== undefined &&
              truckingCost !== "" &&
              parseFloat(
                (materialPriceState + materialTruckPrice) * quantity -
                  (initialMaterialCost + truckingCost) * quantity
              )?.toFixed(2),
            totalProfitPercentage:
              materialPriceState !== undefined &&
              materialPriceState !== "" &&
              materialTruckPrice !== undefined &&
              materialTruckPrice !== "" &&
              quantity !== undefined &&
              quantity !== "" &&
              initialMaterialCost !== undefined &&
              initialMaterialCost !== "" &&
              materialTruckPrice !== undefined &&
              materialTruckPrice !== "" &&
              truckingCost !== undefined &&
              truckingCost !== "" &&
              (
                (((materialPriceState + materialTruckPrice) * quantity -
                  (initialMaterialCost + truckingCost) * quantity) /
                  ((materialPriceState + materialTruckPrice) * quantity)) *
                100
              )?.toFixed(2),
            materialDiameter: materialDiameter,
            materialStatus: values["materialStatus"],
            materialSupply: values["materialSupply"],
            materialTest: values["materialTest"],
            materialMaxDiameter: materialMaxDiameter,
            materialMinDiameter: materialMinDiameter,
            diameter,
          },
        };

        this.addMaterialOrTruckInfo(materialData);
        this.addVendorContact(vendorDetails);
      } else {
        message.error(
          "Please Select Same Units For Material Price & Trucking Price"
        );
      }
    }
  };

  addVendorContact = (vendorDetails) => {
    const { leadDetails, quarryContacts } = this.state;
    let contactsData = quarryContacts?.length > 0 ? quarryContacts : [];
    vendorDetails?.contactDetails
      ?.filter((q) => q?.isPrimaryContact)
      ?.map((c) => {
        if (contactsData?.filter((t) => t.id === c.id)?.length > 0) {
        } else {
          contactsData.push({
            id: c["id"],
            materialId: c?.materialId,
            quarryId: vendorDetails?.id,
            jobId: [leadDetails?.id],
            firstName: c["firstName"],
            lastName: c["lastName"],
            phone: c["phone"],
            email: c["email"],
            notes: c["notes"],
            contactRole: c["contactRole"],
          });
        }
        return true;
      });
    this.setState({
      quarryContacts: contactsData,
    });
  };

  addMaterialOrTruckInfo = (data) => {
    this.setState({
      loading: false,
    });
    let materialInfo =
      this.state.selectedMaterial?.length > 0
        ? this.state?.selectedMaterial
        : [];
    materialInfo.push(data["entityData"]);
    this.setState({
      pickupDetails: [],
      selectedMaterial: materialInfo,
      loading: false,
      quantityType: "Ton",
      selectedMaterialType: "",
      materialSelectedData: "",
      quantity: "",
      recordMaterialData: "",
      materialPopup: false,
      truckingCostType: "Ton",
      totalPriceType: "Ton",
      materialCostType: "Ton",
      truckingPriceType: "Ton",
      selectedPickupAddress: "",
      pickUpLatitude: "",
      pickupLongitude: "",
      finalMaterialData: [],
      filterResultData: [],
      duration: "",
      milesData: "",
      selectVendor: "",
      initialMaterialCost: "",
      materialPriceState: "",
      materialTruckPrice: "",
      materialCostPrice: "",
    });
    if (this.state.recordUpdate === true) {
      let leadData = {
        entityData: {
          material: materialInfo,
        },
      };
      this.updateLead(this.props.match.params.id, leadData);
    }
  };

  handleCheckStatus = (e) => {
    this.setState({ diameter: e });
    this.formRef.current.setFieldsValue({
      materialDiameter: "",
      materialMinDiameter: "",
      materialMaxDiameter: "",
    });
  };

  editMaterial = (data, type) => {
    if (this.state.leadDetails?.stageId !== "Dispatch Approved") {
      if (type === "recordUpdate") {
        this.setState({ recordUpdate: true });
      }
      const { jobInfo } = this.state;
      if (data !== "") {
        let filteredData = [];
        this.state?.selectedMaterial?.forEach((c) => {
          if (c.vendorId === data?.vendorId && c.id === data?.id) {
          } else {
            filteredData.push(c);
          }
        });
        this.setState({ selectedMaterial: filteredData });
      }
      if (jobInfo === "Trucking Job") {
        this.setState({
          materialPopup: true,
          recordMaterialData: data,
          selectedMaterialType: data?.category,
          materialSelectedData: data,
          truckingCostType: data?.truckingCostType
            ? data?.truckingCostType
            : "Ton",
          truckingPriceType: data?.truckingPriceType
            ? data?.truckingPriceType
            : "Ton",
          duration: data?.duration,
          milesData: data?.milesData,
          selectedPickupAddress: data?.pickUpAddress,
          pickUpLatitude: data?.pickUpLatLng?.lat,
          pickupLongitude: data?.pickUpLatLng?.lng,
          customRate: false,
          materialCustomRate: false,
        });
      } else {
        this.getVendorDetails(data);
      }
    }
  };

  getVendorDetails = (data) => {
    const { vendorData } = this.props;
    let vendor = vendorData?.filter((v) => v?.id === data?.vendorId);
    let categoriesList = vendor[0]?.material?.filter(
      (value, index, self) =>
        index === self.findIndex((t) => t.category === value.category)
    );

    this.setState(
      {
        diameter: data?.diameter,
        customRate: false,
        materialCustomRate: false,
        pickupDetails: vendor,
        vendorDetails: vendor[0],
        vendorName: vendor[0]?.quarryName,
        selectedRowKeys: [vendor[0]?.id],
        selectVendor: vendor,
        categoriesList,
        milesData: data?.milesData,
        duration: data?.duration,
        materialValue: data?.category,
        materialPopup: true,
        recordMaterialData: data,
        useMarkUp: data.quantity,
        selectedMaterialType: data?.category,
        materialSelectedData: data,
        quantityType: data?.quantityType ? data?.quantityType : "Ton",
        quantity: data?.quantity,
        truckingCost: data?.truckingCost,
        truckingCostType: data?.truckingCostType
          ? data?.truckingCostType
          : "Ton",
        truckingPriceType: data?.truckingPriceType
          ? data?.truckingPriceType
          : "Ton",
        materialCostType: data?.materialCostType
          ? data?.materialCostType
          : "Ton",
        totalPriceType: data?.totalPriceType ? data?.totalPriceType : "Ton",
        initialMaterialCost: data?.materialCost,
        materialPriceState: data?.totalPrice,
        materialTruckPrice: data?.truckingPrice,
        materialCostPrice: data?.materialCostAtQuarryPerTon,
      },
      () => {
        this.getTopVendors(data);
        this.onSelectMaterialCat(data?.category, "edit");
      }
    );
  };

  onCancelMaterial = () => {
    const { recordMaterialData } = this.state;
    if (
      recordMaterialData !== "" &&
      recordMaterialData !== undefined &&
      recordMaterialData?.length !== 0
    ) {
      let materialInfo =
        this.state.selectedMaterial?.length > 0
          ? this.state?.selectedMaterial
          : [];
      materialInfo.push(recordMaterialData);
      this.setState({
        selectedMaterial: materialInfo,
        recordMaterialData: "",
        selectedMaterialType: "",
        materialPopup: false,
        filterResultData: [],
        finalMaterialData: [],
        initialMaterialCost: "",
        pickupDetails: [],
        materialPriceState: "",
        duration: "",
        milesData: "",
        selectVendor: "",
        materialCostPrice: "",
        materialSelectedData: "",
        vendorDetails: "",
        quantity: "",
        materialTruckPrice: "",
        truckingCost: "",
        customRate: false,
        materialCustomRate: false,
      });
    } else {
      this.setState({ selectedMaterialType: "", materialPopup: false });
    }
  };

  deleteMaterial = (record) => {
    if (this.state.jobInfo === "Trucking Job") {
      let materialInfo = this.state.selectedMaterial.filter(
        (c) => c.id !== record.id
      );
      this.setState({
        selectedMaterial: materialInfo,
      });
      message.info("Trucking Details Deleted Successfully");
    } else {
      let filteredData = [];
      this.state?.selectedMaterial?.forEach((c) => {
        if (c.vendorId === record?.vendorId && c.id === record?.id) {
        } else {
          filteredData.push(c);
        }
      });
      this.setState({
        selectedMaterial: filteredData,
      });
      message.info("Material Deleted Successfully!");
    }
  };

  onSelectMaterialCat = (e, type) => {
    const { materialList } = this.state;
    if (type === "edit") {
      let materialsData = [];
      materialList?.map((newMat) => {
        if (e === newMat?.category) {
          materialsData.push(newMat);
        }
        return true;
      });
      this.setState({
        selectedMaterialType: e,
        finalMaterialData: materialsData,
      });
    } else {
      let materialsData = [];
      materialList?.map((newMat) => {
        if (e === newMat?.category) {
          materialsData.push(newMat);
        }
        return true;
      });
      if (e) {
        this.formRef.current.setFieldsValue({ material: undefined, price: "" });
        this.setState({
          materialSelectedData: "",
          topVendorsData: [],
          vendorDetails: "",
          selectedRowKeys: [],
        });
      }
      this.setState({
        selectedMaterialType: e,
        finalMaterialData: materialsData,
      });
    }
  };

  onSelectMaterial = (e) => {
    const { finalMaterialData } = this.state;
    finalMaterialData?.filter(
      (f) => f.id === e && this.setState({ materialSelectedData: f })
    );
    this.setState({
      topVendorsData: [],
      vendorDetails: "",
      selectedRowKeys: [],
    });
  };

  onFinishContact = (values) => {
    const { leadDetails, jobContactData } = this.state;
    this.setState({ loading: true, isContactVisible: false });
    let contactsData = {
      entityData: {
        companyId: leadDetails?.companyId,
        firstName: values["fName"],
        lastName: values["lName"],
        phone: values["phone"],
        email: values["email"],
        notes: values["notes"],
        contactRole:
          values["role"] === "Add New Role"
            ? values["roleOther"]
            : values["role"],
      },
    };
    if (jobContactData !== "") {
      this.updateContact(contactsData);
    } else {
      this.addContact(contactsData);
    }
    if (this.state.roleCheckBox) {
      this.props.context.updateRolesData(values["roleOther"]);
    }
  };

  addContact = (data) => {
    add("contacts", data)
      .then((result) => {
        if (result.success) {
          this.addContactToJob(result?.data?.data);
          this.getCompanyContacts(this.state.companyId);
          this.setState({
            loading: false,
            newRole: "",
            roleOther: "",
            roleCheckBox: false,
          });
        } else {
          this.setState({
            loading: false,
            roleOther: "",
            newRole: "",
            roleCheckBox: false,
          });
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
          newRole: "",
          roleOther: "",
        });
        console.log(err);
      });
  };

  updateContact = (data) => {
    update(
      appConfig["entityNames"]["updateContact"],
      this.state?.jobContactData?.id,
      data
    )
      .then((res) => {
        if (res.success) {
          this.setState({
            loading: false,
            isCheckBox: false,
            newRole: "",
            roleOther: "",
            roleCheckBox: false,
            jobContactData: "",
            isContactVisible: false,
          });
          this.getLeadDetails(this.props.match.params.id);
        } else {
          this.setState({
            loading: false,
            isCheckBox: false,
            newRole: "",
            roleOther: "",
            roleCheckBox: false,
            jobContactData: "",
            isContactVisible: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loading: false,
          isCheckBox: false,
          newRole: "",
          roleCheckBox: false,
          roleOther: "",
          jobContactData: "",
          isContactVisible: false,
        });
      });
  };

  addContactToJob = (newContact) => {
    this.setState({ selectedContacts: [] });
    const { leadDetails } = this.state;
    let existContactData = leadDetails?.multipleContacts;
    existContactData.push(newContact);
    let data = {
      entityData: {
        multipleContacts: existContactData,
      },
    };
    update(appConfig["entityNames"]["updateLead"], leadDetails?.id, data)
      .then((result) => {
        if (result.success) {
          message.info("Contact Added Successfully");
          this.getLeadDetails(this.props?.match?.params?.id);
          this.setState({
            loading: false,
          });
        } else {
          this.setState({
            loading: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loading: false,
        });
      });
  };

  onSelectVendor = (value, option) => {
    this.formRef.current.setFieldsValue({
      material: "",
      quantity: "",
      materialCategory: "",
      materialPriceState: "",
      totalPrice: "",
    });

    this.setState({
      loading: true,
    });
    const { dropoffLatitude, dropoffLongitude } = this.state;
    let data = this.props.vendorData?.filter((e) => e?.id === option?.key);
    let url =
      "https://maps.googleapis.com/maps/api/distancematrix/json?units=imperial&destinations=" +
      [dropoffLatitude, dropoffLongitude] +
      "&origins=" +
      [data[0]?.lat, data[0]?.lng] +
      "&key=AIzaSyB781k9fNf61hnxE3A6cvcascwhAhIVIK4";

    let milesData = {
      entityData: {
        url,
      },
    };

    let categoriesList = data[0]?.material?.filter(
      (value, index, self) =>
        index === self.findIndex((t) => t.category === value.category)
    );

    add("getMiles", milesData)
      .then((res) =>
        this.setState({
          newVendor: value,
          selectVendor: data,
          categoriesList,
          selectedMaterialType: "",
          finalMaterialData: [],
          pickupDetails: data,
          milesData: res.data.distance,
          duration: res.data.duration,
          loading: false,
          materialPriceState: "",
        })
      )
      .catch((err) => {
        this.setState({
          loading: false,
        });
        console.log(err, "err");
      });
  };

  onChangeVendor = (e) => {
    if (e !== undefined) {
      this.setState({
        vendorName: e,
        materialTruckPrice: "",
      });
    } else {
      this.setState({
        initialMaterialCost: "",
        materialPriceState: "",
        materialCostState: "",
        materialTruckPrice: "",
        selectVendor: [],
        milesData: "",
        duration: "",
        vendorName: "",
        categoriesList: [],
      });
      this.formRef.current.setFieldsValue({
        material: "",
        quantity: "",
        materialCategory: "",
        totalPrice: "",
        truckingPrice: "",
      });
    }
  };

  deleteContact = (data) => {
    this.setState({ loading: true });
    deleteRecord(appConfig["entityNames"]["deleteContactandJob"], data.id)
      .then((res) => {
        if (res.success) {
          this.setState({
            loading: false,
          });
          this.getLeadDetails(this.props?.match?.params?.id);
        } else {
          this.setState({
            loading: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loading: false,
        });
      });
  };

  onSelectChange = (data, value) => {
    this.setState({
      selectedRowKeys: data,
      vendorDetails: value[0],
      initialMaterialCost: value[0]?.material[0]?.price,
      materialCostPrice: value[0]?.material[0]?.price,
      materialPriceState: "",
      truckingCost: "",
    });
    this.formRef.current.setFieldsValue({
      quantity: "",
      totalPrice: "",
      markUp: "",
      truckingCost: "",
      truckingPrice: "",
      materialCost: value[0]?.material[0]?.price,
    });
  };

  DecimalToMixedFraction = (val) => {
    const decimal = eval(val);
    const wholeNumber = Math.floor(decimal);
    const fractionalPart = decimal - wholeNumber;
    const fraction = this.decimalToFraction(fractionalPart);

    const mixedFraction =
      wholeNumber !== 0 ? `${wholeNumber} ${fraction}` : `${fraction}`;

    return mixedFraction;
  };

  decimalToFraction = (decimal) => {
    const EPSILON = 1.0e-9;
    let numerator = decimal;
    let denominator = 1;

    while (Math.abs(Math.round(numerator) - numerator) > EPSILON) {
      numerator *= 10;
      denominator *= 10;
    }

    const gcd = this.getGreatestCommonDivisor(numerator, denominator);
    numerator /= gcd;
    denominator /= gcd;

    return `${Math.floor(numerator)}/${Math.floor(denominator)}`;
  };

  getGreatestCommonDivisor = (a, b) => {
    if (b === 0) {
      return a;
    }
    return this.getGreatestCommonDivisor(b, a % b);
  };

  getTopVendors = (values) => {
    const {
      materialSelectedData,
      dropoffLatitude,
      dropoffLongitude,
      diameter,
    } = this.state;

    let materialMinDiameter = 0,
      materialMaxDiameter = 0,
      materialDiameter = 0;

    if (diameter) {
      materialMinDiameter =
        values["materialMinDiameter"].split(" ")?.length !== 2 &&
        String(parseInt(values["materialMinDiameter"])) !==
          values["materialMinDiameter"]
          ? this.DecimalToMixedFraction(values["materialMinDiameter"])
          : values["materialMinDiameter"];

      materialMaxDiameter =
        values["materialMaxDiameter"].split(" ")?.length !== 2 &&
        String(parseInt(values["materialMaxDiameter"])) !==
          values["materialMaxDiameter"]
          ? this.DecimalToMixedFraction(values["materialMaxDiameter"])
          : values["materialMaxDiameter"];
    } else {
      materialDiameter =
        values["materialDiameter"].split(" ")?.length !== 2 &&
        String(parseInt(values["materialDiameter"])) !==
          values["materialDiameter"]
          ? this.DecimalToMixedFraction(values["materialDiameter"])
          : values["materialDiameter"];
    }

    if (materialSelectedData !== "") {
      this.setState({
        loading: true,
        initialMaterialCost: materialSelectedData?.materialCost
          ? materialSelectedData?.materialCost
          : "",
      });

      let data = {
        entityData: {
          material: materialSelectedData,
          dropOffLatLng: { lat: dropoffLatitude, lng: dropoffLongitude },
          materialDiameter: materialDiameter,
          materialStatus: values["materialStatus"],
          materialSupply: values["materialSupply"],
          materialTest: values["materialTest"],
          materialMaxDiameter: materialMaxDiameter,
          materialMinDiameter: materialMinDiameter,
          diameter,
        },
      };
      this.FindTopVendors(data);
    } else {
      message.error("Please Select Material!");
    }
  };

  FindTopVendors = (data) => {
    add("getTopQuarries", data).then((res) => {
      this.setState({
        topVendorsData: res.data,
        loading: false,
      });
    });
  };

  resetvendorValues = () => {
    this.setState({
      topVendorsData: [],
      selectedRowKeys: [],
    });
  };

  onChangeOverWeight = (e) => {
    this.setState({
      overWeightPermitState: e?.target?.value,
    });
    if (e?.target?.value === "No") {
      this.formRef.current.setFieldsValue({
        overWeightExpiryDate: "",
      });
      this.setState({
        quoteAttachment: "",
        quoteAttachmentId: "",
      });
    }
  };

  onFinishTruckDetails = (values) => {
    const {
      selectedAddress,
      latitude,
      longitude,
      selectedTruckCode,
      companyData,
      citySearch,
      quoteAttachmentId,
      equipmentAttachment,
      fileType,
    } = this.state;

    if (values["overWeightPermit"] === "Yes" && quoteAttachmentId === "") {
      message.info("Please Attach Your Document!");
      return;
    }
    if (
      (citySearch !== "" && citySearch !== undefined) ||
      (selectedAddress !== "" && selectedAddress !== undefined)
    ) {
      let equipmentTypeDetails = {
        carrier_name: companyData?.carrier_name,
        id: uuidv4(),
        parking_location: selectedAddress,
        lat: latitude,
        lng: longitude,
        truck_type: values["truck_type"],
        overWeightPermit: values["overWeightPermit"],
        overWeightExpiryDate:
          values["overWeightPermit"] === "Yes"
            ? moment(values["overWeightExpiryDate"]).format("L")
            : "",
        empty_weight: values["empty_weight"],
        truck_code: selectedTruckCode,
        carrierId: companyData?.id,
        equipmentAttachment:
          values["overWeightPermit"] === "Yes" ? equipmentAttachment : "",
        docAttachmentId:
          values["overWeightPermit"] === "Yes" ? quoteAttachmentId : "",
        fileType: fileType,
      };

      let finalData = {
        entityData: {
          carrierDetails: [equipmentTypeDetails],
        },
      };
      this.setState({
        addTruck: false,
      });
      this.updateCompanyDetails(companyData.id, finalData);
      message.success("Truck Details Added Successfully!");
    } else {
      message.info("Please Enter Parking Location !");
    }
  };

  handleUploadPic = async (info) => {
    this.setState({
      imageLoading: true,
      loading: true,
    });
    switch (info.file.status) {
      case "done":
        if (info.fileList.length > 0 && info.file.status !== "removed") {
          try {
            if (info.file.size > 0) {
              Storage.put(info.file.uid, info.file.originFileObj, {
                contentType: info.file.type,
              }).then((result) => {
                Storage.get(result.key).then(() => {
                  this.setState({
                    quoteAttachmentId: result.key,
                    equipmentAttachment: result,
                    fileType: info.file.type,
                    imageLoading: false,
                    loading: false,
                  });
                });
              });
            } else {
              this.setState({
                imageLoading: false,
                loading: false,
              });
            }
          } catch (err) {
            console.log(err, "errr");
          }
        }
        break;
      case "removed":
        this.setState({
          equipmentAttachment: "",
          quoteAttachmentId: "",
          imageLoading: false,
          loading: false,
          percentage: 0,
        });
        break;
      default:
    }
  };

  welcomeCallCondition = (id, status, companyData) => {
    if (companyData?.carrierDetails?.length > 0) {
      if (companyData?.payment_terms && companyData?.payment_terms !== "") {
        if (
          companyData?.insurance_expiry &&
          companyData?.insurance_expiry !== ""
        ) {
          if (
            companyData?.direct_deposit &&
            companyData?.direct_deposit !== ""
          ) {
            if (companyData?.usdot && companyData?.usdot !== "") {
              this.getCompanies(id, status, companyData);
            } else {
              message.error("Please Enter USDOT To Proceed");
            }
          } else {
            message.error("Please Enter Deposit Method To Proceed");
          }
        } else {
          message.error("Please Enter Insurance Expiration Date To Proceed");
        }
      } else {
        message.error("Please Enter Payment Terms To Proceed");
      }
    } else {
      message.error("Please Enter Equipment Details To Proceed");
      this.setState({ addTruck: true });
    }
  };

  render() {
    const {
      companyData,
      overWeightPermitState,
      imageLoading,
      addTruck,
      customRate,
      selectedRowKeys,
      diameter,
      materialCategory,
      finalMaterialData,
      quantity,
      truckingCostType,
      useMarkUp,
      truckingCost,
      topVendorsData,
      materialCostType,
      materialCustomRate,
      citySearch,
      isModalVisible,
      selectedStatus,
      jobInfo,
      leadDetails,
      dropAddress,
      isContactVisible,
      contactsData,
      selectedMaterial,
      truckDropInfo,
      jobContactData,
      newRole,
      materialPopup,
      recordMaterialData,
      loading,
      milesData,
      initialMaterialCost,
      materialPriceState,
      materialTruckPrice,
      duration,
      truckingPriceType,
      totalPriceType,
      openDropdown,
      funnelData,
      leadsData,
      isHovering,
    } = this.state;

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };

    const topVendorsColumns = [
      {
        title: "VENDOR NAME",
        dataIndex: "quarryName",
        key: "quarryName",
        sorter: false,
        width: "40%",
        className: "col_style_quarry",
        render: (quarryName, record) => {
          return (
            <Row
              style={{
                display: "flex",
                alignItems: "center",
                minWidth: "fit-content",
              }}
              onClick={() => this.onSelectChange([record.id], [record])}
            >
              {quarryName}
            </Row>
          );
        },
      },
      {
        title: "RUN & RATE INFORMATION",
        dataIndex: "distance",
        key: "distance",
        sorter: false,
        width: "40%",
        className: "col_style_quarry",
        render: (distance, record) => {
          return (
            <Row
              style={{
                display: "flex",
                alignItems: "center",
                minWidth: "fit-content",
              }}
              onClick={() => this.onSelectChange([record.id], [record])}
            >
              {distance + "les, " + record?.duration}
            </Row>
          );
        },
      },
      {
        title: "COST / Ton",
        dataIndex: "material",
        key: "material",
        sorter: false,
        width: "20%",
        className: "col_style_quarry",
        render: (material, record) => {
          return (
            <Row
              style={{
                display: "flex",
                alignItems: "center",
                minWidth: "fit-content",
              }}
              onClick={() => this.onSelectChange([record.id], [record])}
            >
              {"$" + material[0]?.price?.toFixed(2)}
            </Row>
          );
        },
      },
    ];

    const selectAfter = (
      <Select
        defaultValue={this.state?.quantityType}
        className="select-after"
        onChange={(e) => {
          this.setState({ quantityType: e });
        }}
      >
        <Option value="Ton">Ton</Option>
        <Option value="Load">Load</Option>
        <Option value="Yard">Yard</Option>
      </Select>
    );

    const selectAfterMaterial = (
      <Select
        defaultValue={this.state?.materialCostType}
        className="select-after"
        onChange={(e) => {
          this.setState({ materialCostType: e });
        }}
      >
        <Option value="Ton">Ton</Option>
        <Option value="Load">Load</Option>
        <Option value="Yard">Yard</Option>
      </Select>
    );

    const selectAfterTruck = (
      <Select
        defaultValue={this.state?.truckingCostType}
        className="select-after"
        onChange={(e) => {
          this.setState({ truckingCostType: e });
        }}
      >
        <Option value="Ton">Ton</Option>
        <Option value="Load">Load</Option>
        <Option value="Hour">Hour</Option>
      </Select>
    );

    const selectAfterTruckPrice = (
      <Select
        defaultValue={this.state?.truckingPriceType}
        className="select-after"
        onChange={(e) => {
          this.setState({ truckingPriceType: e });
        }}
      >
        <Option value="Ton">Ton</Option>
        <Option value="Load">Load</Option>
        <Option value="Hour">Hour</Option>
      </Select>
    );

    const selectAfterCustomer = (
      <Select
        defaultValue={this.state?.totalPriceType}
        className="select-after"
        onChange={(e) => {
          this.setState({ totalPriceType: e });
        }}
      >
        <Option value="Ton">Ton</Option>
        <Option value="Load">Load</Option>
      </Select>
    );

    const classes = {
      board: {
        display: "flex",
        margin: "0 auto",
        height: window.width <= 377 && window.width <= 799 ? "75vh" : "60vh",
      },
      column: {
        width:
          window.location.pathname === "/app/trucking-material"
            ? "240px"
            : "191px",
        height: "100%",
        margin: "0 auto",
      },
      columnHead: {
        textAlign: "center",
        padding: 10,
        borderLeft: "none",
        height: "40px",
      },
      columnHeads: {
        textAlign: "center",
        padding: 8,
        borderLeft: "none",
        height: "60px",
      },
      item: {
        padding: 10,
        margin: 5,
        fontSize: "0.8em",
        cursor: "pointer",
        backgroundColor: "white",
        borderRadius: "5px",
      },
    };

    const channels = funnelData;

    return (
      <>
        <Loading enableLoading={this.state.loading} />

        <div data-aos="flip-left">
          <section style={classes.board}>
            {channels.map(
              (channel) =>
                channel !== "Job Lead" && (
                  <KanbanColumn
                    key={channel}
                    status={channel}
                    isOwnerOperator={leadsData[0]?.isOwnerOperator === true}
                  >
                    <div style={classes.column}>
                      <div
                        style={
                          leadsData[0]?.isOwnerOperator === true
                            ? classes.columnHeads
                            : classes.columnHead
                        }
                        className="customer_leadHeading customer_Lead"
                      >
                        {`${channel} (${
                          leadsData?.filter((l) => l?.stageId === channel)
                            ?.length
                        })`}
                      </div>
                      <div
                        className="kanbanscroll"
                        style={{ height: "92%", overflowY: "auto" }}
                      >
                        {leadsData
                          ?.filter((item) => item.stageId === channel)
                          .map((item) =>
                            item?.leadType &&
                            item?.leadType[0]?.value === "Material Sales" ? (
                              <KanbanItem
                                key={item.id}
                                id={item.id}
                                onDrop={this.update}
                                isOwnerOperator={false}
                              >
                                <div
                                  onDoubleClick={() => {
                                    this.onDoubleClick(item.id);
                                    this.props.context.updateSideronCollapse(
                                      false
                                    );
                                  }}
                                  style={{
                                    padding: 10,
                                    margin: 5,
                                    fontSize: "0.8em",
                                    cursor: "pointer",
                                    backgroundColor: "white",
                                    borderRadius: "5px",
                                    boxShadow:
                                      isHovering === item.id
                                        ? "0 1px 2px -2px rgb(0 0 0 / 16%), 0 3px 6px 0 rgb(0 0 0 / 12%), 0 5px 12px 4px rgb(0 0 0 / 9%)"
                                        : "none",
                                  }}
                                  onMouseEnter={() =>
                                    this.handleMouseEnter(item.id)
                                  }
                                  onMouseLeave={() =>
                                    this.handleMouseLeave(item.id)
                                  }
                                >
                                  <Row>
                                    <Col span={24}>
                                      <div className="grid_Name">
                                        <b>
                                          {item?.jobNumber === undefined
                                            ? ""
                                            : "Job #" + item?.jobNumber}
                                          , {item?.company}
                                        </b>
                                      </div>
                                    </Col>

                                    <Col
                                      span={24}
                                      className="grid_Company companynamed"
                                    >
                                      {item?.jobType}
                                    </Col>

                                    <Col
                                      span={24}
                                      className="grid_Name namegridss"
                                    >
                                      {item?.firstName ? (
                                        <>
                                          {item?.firstName
                                            ? item?.firstName +
                                              " " +
                                              item?.lastName
                                            : ""}
                                        </>
                                      ) : (
                                        <>
                                          {item?.contactperson ===
                                          "undefined undefined"
                                            ? ""
                                            : item?.contactperson
                                            ? item?.contactperson
                                            : item?.multipleContacts
                                            ? item?.multipleContacts?.map(
                                                (e) => (
                                                  <div>
                                                    {e?.firstName +
                                                      " " +
                                                      e?.lastName}
                                                  </div>
                                                )
                                              )
                                            : ""}
                                        </>
                                      )}
                                    </Col>
                                  </Row>
                                </div>
                              </KanbanItem>
                            ) : (
                              <KanbanItem
                                key={item.id}
                                id={item.id}
                                onDrop={this.updateCompany}
                                isOwnerOperator={true}
                              >
                                <div
                                  style={classes.item}
                                  onDoubleClick={() => {
                                    window.location = `/app/owner-operator-profile/${item.id}`;
                                    this.props.context.updateSideronCollapse(
                                      false
                                    );
                                  }}
                                >
                                  <Row>
                                    <Col span={24}>
                                      <div className="grid_Name">
                                        <b>{item?.company}</b>
                                      </div>
                                    </Col>
                                    <Row>
                                      {item?.contactDetails
                                        ?.filter(
                                          (e) => e?.isPrimaryContact === true
                                        )
                                        .map((f) => (
                                          <React.Fragment key={f.id}>
                                            <Col
                                              span={24}
                                              className="grid_Name"
                                            >
                                              {f?.firstName !== undefined
                                                ? f?.firstName
                                                : " " + f?.lastName !==
                                                  undefined
                                                ? f?.lastName
                                                : ""}
                                            </Col>
                                            <Col
                                              span={24}
                                              className="grid_Company"
                                            >
                                              {f?.phone}
                                            </Col>
                                            <Col
                                              span={24}
                                              className="grid_Company companynamed"
                                            >
                                              {f?.email}
                                            </Col>
                                          </React.Fragment>
                                        ))}
                                    </Row>
                                    <Col span={24} className="grid_Name">
                                      Truck Count:{" "}
                                      {`${item?.carrierDetails?.length}`}
                                    </Col>
                                  </Row>
                                </div>
                              </KanbanItem>
                            )
                          )}
                      </div>
                    </div>
                  </KanbanColumn>
                )
            )}
          </section>
        </div>
        {isModalVisible && (
          <BaseModal
            title={
              selectedStatus === "Build Quote"
                ? `Build Quote Form #${leadDetails?.jobNumber}`
                : `Update Job Profile #${leadDetails?.jobNumber}`
            }
            onCancel={() =>
              this.setState({
                isModalVisible: false,
                selectedStatus: "",
                quoteAttachment: "",
                isCheckBox: false,
                isCheckBoxMaterial: false,
                isCheckBoxTruckType: false,
                jobInfo: "",
                truckDropInfo: false,
                selectedMaterial: [],
                showSpecificDate: false,
                iscalenderVisible: false,
                openDropdown: "",
                salesCommission: "",
              })
            }
            formId="LeadForm"
            loading={this.state.loading}
            className="antmodal_grid headermodal"
            width={"80%"}
          ></BaseModal>
        )}
      </>
    );
  }
}

// Remove the old HOC wrappers and export with DndProvider
const DraggableCardWithContext = withAppContext(withRouter(DraggableCard));

// Export a wrapper component that provides DndContext
const DraggableCardWrapper = (props) => (
  // <DndProvider backend={HTML5Backend}>
  <DraggableCardWithContext {...props} />
  // </DndProvider>
);

export default DraggableCardWrapper;
